export default "__VITE_ASSET__CfC0hMbR__"